<div class="modal-report-explosive">
    <img appImageSelector alt="mt-image" imageType="icon" imageKey="close-gray" class="close-modal" (click)="activeModal.dismiss()">
    <app-main-table [tableConfig]="tableConfig"></app-main-table>
</div>